import {SectionType} from '../api/models';

export const getSectionTitle = (sectionType: SectionType): string => {
    switch (sectionType) {
        case SectionType.HERO:
            return 'Home';
        case SectionType.ABOUT:
            return 'About';
        case SectionType.MEDIA:
            return 'Media';
        case SectionType.CONTACT:
            return 'Contact';
        default:
            return '';
    }
};

export const questions: {question: string; answer: string}[] = [
    {
        question: 'How do I get started?',
        answer:
            "To get started, simply click the Get started button above. Follow the on-screen instructions to set up your website, and you're all set",
    },
    {
        question: 'Are there any additional hidden costs?',
        answer: 'Nope. There are no additional hidden costs for using Socialmart',
    },
    {
        question: "I don't understand how to use Socialmart.",
        answer:
            'Feel free to see our demo video which demonstrates how you can use Socialmart to create your own website. Check the demo above',
    },
    {
        question: 'I am facing some issues, to whom can I reach out?',
        answer:
            "We're sorry to hear that you're facing issues in using Socialmart. Feel free to drop an email at hello@socialmart.com",
    },
    {
        question: 'Can I use a custom domain name to route to my website?',
        answer: "Reach out to us at hello@socialmart.com, we're constantly building new capabilities.",
    },
];
